import { Component, OnInit, HostListener, Input, AfterViewInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable, BehaviorSubject, firstValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';
import { SiteContext } from '../../model';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AppService } from '../../services/app.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { AppContext, UrlState } from 'src/app/services/app-context.service';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';
import Constants from 'src/app/pages/checkout/utils/Constants';
import { HotelService } from 'src/app/services/hotel.service';
import countrycodes from 'src/app/pages/checkout/utils/nationality.json';
import { Location } from '@angular/common';
import { StorageService } from 'src/app/services/storage.service';
import { ToasterService } from 'src/app/services/toaster.service';
import { LoginSignupService } from 'src/app/services/login-signup.service';
import { LoginSignupComponent } from 'src/app/pages/login-signup/login-signup.component';
import { AuthUtilsService } from 'src/app/services/auth-utils.service';
import { CookieService } from 'ngx-cookie-service';
declare const $zoho: any;

@Component({
  selector: 'travel-ui-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, AfterViewInit {
  isUserMenuOpen = false;
  isCurrencyMenuOpen = false;
  siteContext$: BehaviorSubject<SiteContext | null> | undefined;
  @Input()
  displaySetting: any;
  enableCurrency: boolean = false;
  enableUserMenu: boolean = false;
  currencyList$!: Observable<any>;
  headerData: any;
  selectedCurrency = 'USD';
  isMobileToggle = false;
  mobileView = false;
  countryList: {
    name: string;
    code: string;
  }[] = countrycodes.countrycodes;
  nationality!: string;
  defaultNationality!: string;
  userDetails: any;
  urlState: UrlState = { currentUrl: '', flag: false };
  isHomeScreen =false;
  routerSubscription:any;
  constructor(
    private breakpointObserver: BreakpointObserver,
    public auth: AuthService,
    public appService: AppService,
    public appContext: AppContext,
    private router: Router,
    public dialog: MatDialog,
    private location: Location,
    public hotelService: HotelService,
    private storage: StorageService,
    private toasterSvc: ToasterService,
    public loginSignUpService: LoginSignupService,
    private route: ActivatedRoute,
    private authUtils: AuthUtilsService,
    private cookieService: CookieService
  ) {
    this.isHandset$.subscribe((isMobile) => {
      this.mobileView = isMobile;
    });

    this.storage.userDetails.subscribe((user: any) => {
      this.userDetails = user;
    });
    this.appContext.urlState$.subscribe((state: UrlState) => {
      this.urlState = state;
    })
  }

  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(map((result) => result.matches));
  headerBackground = 'transparent';
  changeNavElementsColor = false;
  sidenavWidth = 0;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const number =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    if (number > 330) {
      this.headerBackground = '#000';
      this.changeNavElementsColor = true;
    } else {
      this.headerBackground = 'transparent';
      this.changeNavElementsColor = false;
    }
  }

  toggleNav() {
    this.sidenavWidth = !this.sidenavWidth ? (this.sidenavWidth = 250) : 0;
  }

  ngOnInit() {
    if (!this.displaySetting) {
      this.displaySetting = JSON.parse(sessionStorage.getItem('SiteContext') as string).displaySetting;
    }
    this.route.queryParams.subscribe(params => {
      const currency = params['currency'] ? params['currency']?.toUpperCase() : "";
      if (currency && this.displaySetting?.header?.allowCurrencies?.includes(currency)) {
        this.selectedCurrency = currency;
        this.appContext.selectedCurrencyCode.next(currency);
        this.appContext.isCurrencyChanged.next(true);
        this.appContext.setCurrency(currency);
        sessionStorage.setItem("currency", currency);

      } else {
        const savedCurrency = sessionStorage.getItem('currency');
        if (savedCurrency) {
          this.selectedCurrency = savedCurrency;
          this.appContext.selectedCurrencyCode.next(savedCurrency);
          this.appContext.setCurrency(savedCurrency);
          this.appContext.isCurrencyChanged.next(true);
        }
      }
    });
  }

  ngAfterViewInit() {
    if (this.isBookMyGetaway() && !this.userDetails) {
      this.authUtils.checkAndSetUserFromToken();
    }
  }
  checkIfHomeScreen(): void {
    // Initial check - more robust home screen detection
    this.isHomeScreen = this.isHomeRoute(this.router.url);

    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        console.log("Navigation ended, new URL:", event.url);
        this.isHomeScreen = this.isHomeRoute(event.url);
        console.log("this.isHomeScreen", this.isHomeScreen);
      }
    });
  }

  private isHomeRoute(url: string): boolean {
    // Check for exact home route or home route with query parameters
    const cleanUrl = url.split('?')[0]; // Remove query parameters
    return cleanUrl === '/' || cleanUrl === '' || cleanUrl === '/home';
  }
  clearUserSession() {
    localStorage.removeItem('user');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('token');
  }

  logout() {
    if (this.appContext.siteName === 'HotelCollection') {
      this.clearUserSession();
      function getCookie(name: any) {
        const value = '; ' + document.cookie;
        const parts = value.split('; ' + name + '=');
        if (parts.length === 2) return parts.pop()?.split(';').shift();
      }
      const shopify_customer_id = getCookie('shopify_customer_id');
      if (shopify_customer_id)
        localStorage.setItem('logout_shopify_customer_id', shopify_customer_id);

      const date = new Date();
      const time = date.getTime();
      const expireTime = time - 1000 * 36000;
      date.setTime(expireTime);
      document.cookie =
        'shopify_customer_id=;domain=.hotelcollection.com;expires=' +
        date +
        ';SameSite=none;Secure=false';
      this.storage.setUser(null);
      this.router.navigate(['/login']);
      this.toasterSvc.success('Logout susuccessfully!', 5000);
    }
    this.clearUserSession();
    this.auth.logout();
    window.location.reload();
  }

  async logoutSupabase() {
    function getCookie(name: any) {
      const value = "; " + document.cookie;
      const parts = value.split("; " + name + "=");
      if (parts.length === 2) return parts.pop()?.split(";").shift();
    }
    const token = getCookie("token") || localStorage.getItem('token');
    const refreshToken = getCookie("refreshToken") || localStorage.getItem('refreshToken');

    this.clearUserSession();
    if (this.appContext.siteName == 'Gocaribbea') {
      document.cookie = "token=;domain=.gocaribbea.com;expires=" + ";SameSite=none;Secure=false";
      document.cookie = "refreshToken=;domain=.gocaribbea.com;expires=" + ";SameSite=none;Secure=false";
    }
    if (this.appContext.siteName == 'ShamalGroup') {
      document.cookie = "token=;domain=.shamaltravels.com;expires=" + ";SameSite=none;Secure=false";
      document.cookie = "refreshToken=;domain=.shamaltravels.com;expires=" + ";SameSite=none;Secure=false";
    }
    this.storage.setUser(null);

    if (token && refreshToken) {
      try {
        await firstValueFrom(this.loginSignUpService.logoutUser(token as string, refreshToken as string));
      } catch (err) {
        console.error('logoutUser API failed:', err);
      }
    }

    if (this.appContext.siteName === 'alldotgay') {
      this.router.navigate(['/']);
      return;
    }

    const currentPath = this.location.path();
    if (this.appContext.context?.defaultRedirectionUrl && !currentPath.includes('hotels')) {
      window.location.href = this.appContext.context.defaultRedirectionUrl;
    } else if (!currentPath.includes('hotels')) {
      this.router.navigate(['']);
    }
  }

  onLogin() {
    this.auth.login();

  }
  openModal() {
    this.dialog.open(LoginSignupComponent);
  }

  // getSymbol(currencyCode: string): string | undefined {
  //   return this.appContext.getCurrencySymbol(currencyCode);
  // }

  onChangeCurrency(selectedCurrency: any) {
    if (this.selectedCurrency !== selectedCurrency) {
      this.selectedCurrency = selectedCurrency;
      sessionStorage.setItem("currency", selectedCurrency);
      this.isCurrencyMenuOpen = false;
      this.appContext.isCurrencyChanged.next(true);
      this.appContext.selectedCurrencyCode.next(selectedCurrency);
      this.appContext.setCurrency(selectedCurrency);
      this.updateUrlAndFlag();
      if (this.isMobileToggle) this.isMobileToggle = !this.isMobileToggle
    }

    // this.appService
    //   .changeCurrency(selectedCurrency)
    //   .subscribe((newCurrency) => {
    //     if (this.appContext.siteName == Constants.SiteNames.joy || this.appContext.siteName == Constants.SiteNames.roomantic) {
    //       this.selectedCurrency = selectedCurrency;
    //       this.updateUrlAndFlag();
    //     }
    //     else if (this.appContext.context?.defaultRedirectionUrl) {
    //       this.selectedCurrency = selectedCurrency;
    //       window.location.href = this.appContext.context?.externalHomePage;
    //     }
    //     else {
    //       this.router.navigate(['']);
    //       this.selectedCurrency = selectedCurrency;
    //     }
    //   });
    // this.isCurrencyMenuOpen = false;
  }

  updateUrlAndFlag() {
    const newUrl = window.location.href;
    const url = window.location.pathname;
    const newFlag = true;
    if (url.includes('checkout')) {
      const parsedUrl = new URL(this.urlState.currentUrl);
      parsedUrl.searchParams.delete('searchId');
      window.location.href = parsedUrl.pathname;
    }
    if (url.includes('hotels')) {
      this.appContext.currencyChangeonDetails$.next(true);
    }
    this.appContext.updateUrlState(newUrl, newFlag);
  }

  getAvailablePoints(user: any) {
    if (user != null) return user.availPoint;
    return 0;
  }

  setContext() {
    this.isUserMenuOpen = false;
    // const dialogRef = this.dialog.open(SetContextComponent, {
    //   width: '500px',
    //   //  height: '800px'
    // });

    // dialogRef.afterClosed().subscribe(result => {
    //   if (result === true) {
    //     //  this.fetchBookingDetails();
    //   }
    // });
  }

  getImageUrl(link: string) {
    const item = this.appContext.hmt_header_link_icons.find((item: { title: string, link: string }) => item.title === link);
    return item ? item.link : "";
  }
  openChat(): void {
    if ($zoho && $zoho.salesiq) {
      $zoho.salesiq.floatwindow.visible('show');
    }
    else {
      console.error("zoho chat window is not initialized..");
    }
  }

  isBookMyGetaway(): boolean {
    return (
      this.appContext?.siteName === 'BookMyGataway' ||
      this.appContext?.siteName === 'BookMyGetaway'
    );
  }


 customSSOLogin() {
  const redirectUrl = encodeURIComponent(window.location.href);
  const url = `${Constants.BookMyGetawayLoginUrl}?redirecturl=${redirectUrl}`;
  window.open(url, "_self");
}

customSSOLogout(isManual: boolean = true) {
  this.storage.setUser(null);
  this.clearUserSession();

  this.cookieService.delete('auth_token', '/', '.bookmygetaway.co.uk');

  localStorage.clear();
  sessionStorage.clear();

  const currentPath = this.location.path();
  let loginUrl = `https://bookmygetaway.co.uk/login`;

  if (isManual) {
    loginUrl += `?logout=true`;
  } else {
    const redirectUrl = encodeURIComponent(window.location.origin + currentPath);
    loginUrl += `?redirecturl=${redirectUrl}`;
  }
  window.location.href = loginUrl;
}

 ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}



